import React from 'react';
import PropTypes from 'prop-types';

import * as passwordSchema from 'lib/auth/passwordSchema';

import PasswordInput from '../PasswordInput';

const PasswordInputWithStrength = ({
  name,
  className,
  label,
  helperText,
  value,
  onChange,
  onBlur,
  required,
  error,
  minScore,
  scoreWords,
  scoreColors,
  calcPasswordScore,
}) => {
  const [score, setScore] = React.useState(0);

  const handleOnChange = (ev) => {
    const value = ev.target.value;

    const newScore = calcPasswordScore(value);

    setScore(newScore);

    if (!onChange) return;

    const isPassScore = newScore >= minScore;

    onChange(value, newScore, isPassScore);
  };

  const lookupScoreWord = (score) => {
    if (score < 0 || score > scoreWords.length)
      throw new Error('invalid score');

    const scoreWord = scoreWords[score];

    return scoreWord;
  };

  const lookupScoreColor = (score) => {
    if (score < 0 || score > scoreColors.length)
      throw new Error('invalid score');

    const scoreColor = scoreColors[score];

    return scoreColor;
  };

  const _helperText = (
    <React.Fragment>
      {value.length > 0 && score !== 0 && (
        <p style={{ color: lookupScoreColor(score) }}>
          {lookupScoreWord(score)}
        </p>
      )}
      {helperText && <p style={{ color: 'inherit' }}>{helperText}</p>}
    </React.Fragment>
  );

  return (
    <PasswordInput
      name={name}
      className={className}
      label={label}
      helperText={_helperText}
      value={value}
      onChange={handleOnChange}
      onBlur={onBlur}
      required={required}
      error={error}
    />
  );
};

const calcPasswordScore = (password) => {
  const rules = [
    passwordSchema.minLength8,
    passwordSchema.containsNumbers,
    passwordSchema.containsLowerCaseAlphas,
    passwordSchema.containsUpperCaseAlphas,
    passwordSchema.containsSpecialChars,
  ];

  const score = rules.reduce((score, rule) => {
    const ruleFulfilled = rule.isValidSync(password);

    if (ruleFulfilled) score += 1;

    return score;
  }, 0);

  return score;
};

PasswordInputWithStrength.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  required: PropTypes.bool,
  minScore: PropTypes.number,
  scoreWords: PropTypes.arrayOf(PropTypes.string),
  scoreColors: PropTypes.arrayOf(PropTypes.string),
  calcPasswordScore: PropTypes.func.isRequired,
};

PasswordInputWithStrength.defaultProps = {
  className: null,
  label: null,
  helperText: null,
  value: undefined,
  onChange: undefined,
  onBlur: () => {},
  required: false,
  minScore: 0,
  scoreWords: [
    'Password Strength: Standing Wall Push-Up',
    'Password Strength: Standing Wall Push-Up',
    'Password Strength: Floor Push-Up',
    'Password Strength: Empty Bar Bench Press',
    'Password Strength: 1-Plate Bench Press',
    'Password Strength: 2-Plate Bench Press!!!',
  ],
  scoreColors: [
    '#ddd',
    '#a42e27',
    '#e85537',
    '#f4853a',
    '#ffc938',
    '#2FBF71',
  ],
  calcPasswordScore,
};

export default PasswordInputWithStrength;
